import "./test_flash_message.scss";

import { FlashMessage } from "@components/flash_messages/flash_message";
import React, { FC, useState } from "react";

enum FlashType {
  Notice = "notice",
  Warning = "warning",
  Error = "error",
}

const TestFlashMessage: FC = () => {
  const [flashType, flash] = useState<FlashType | undefined>();

  const messageText = `We can't find the item you are looking for.  And this is a ${flashType} message.`;

  const handleClickNotice = () => flash(FlashType.Notice);

  const handleClickWarning = () => flash(FlashType.Warning);

  const handleClickError = () => flash(FlashType.Error);

  const handleFlashReset = () => flash(undefined);

  return (
    <section className="test-flash-message">
      <button onClick={handleClickNotice}>Notice Flash Message</button>
      <button onClick={handleClickWarning}>Warning Flash Message</button>
      <button onClick={handleClickError}>Error Flash Message</button>
      <button onClick={handleFlashReset}>Reset Flashes</button>
      {!!flashType && (
        <FlashMessage key={flashType} message={messageText} type={flashType} />
      )}
    </section>
  );
};

export { TestFlashMessage };
